import React from "react";
import { Toaster } from "sonner";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const DISCORD_URL = "https://discord.gg/nEvwBUtqAV";

const SECTIONS = [
  {
    title: "1. Respect every competitor",
    body: "Treat everyone like you want to be treated. No harassment, slurs, personal attacks, doxxing, sexual content, or hate speech — in chat, voice, social posts, or DMs. Zero tolerance.",
  },
  {
    title: "2. Play with integrity",
    body: "No cheats, glitches, match-fixing, account sharing, smurfing, or collusion. If you spot an opponent doing it, report them in Discord with evidence.",
  },
  {
    title: "3. Keep communication clean",
    body: "Trash talk is part of esports. Racist, sexist, homophobic, transphobic, or ableist 'jokes' aren't. If a mod says stop, stop.",
  },
  {
    title: "4. Respect the format & admins",
    body: "Show up on time. Follow the rules of the bracket (check-in windows, maps, scoring, tiebreakers). Admin decisions on disputes are final.",
  },
  {
    title: "5. Own your mistakes",
    body: "If you mess up, own it, apologise, and move on. This is a community — not a courtroom.",
  },
  {
    title: "6. Enforcement",
    body: "First offence: warning. Second: ban from the current tournament. Third: permanent ban from the platform + Discord. Severe offences (cheating, harassment, illegal content) are a permanent ban on the first strike.",
  },
];

export default function CodeOfConductPage() {
  return (
    <div className="min-h-screen bg-[#050505] text-zinc-200">
      <Toaster position="top-right" theme="dark" />
      <Navbar />
      <section className="max-w-4xl mx-auto px-6 pt-12 pb-20">
        <div className="text-[10px] uppercase tracking-[0.3em] text-red-400 font-mono mb-3">
          Spicy Community
        </div>
        <h1 className="font-display font-extrabold text-4xl md:text-5xl mb-3">
          Code of <span className="text-red-500">Conduct</span>
        </h1>
        <p className="text-zinc-400 max-w-2xl">
          The rules that keep this community sharp, fair, and fun. By joining any tournament
          or participating in our Discord, you agree to the below.
        </p>
        <div className="mt-10 space-y-5">
          {SECTIONS.map((s, i) => (
            <div key={i} className="glass-dark rounded-2xl p-6">
              <h2 className="font-display font-bold text-lg mb-1.5 text-white">{s.title}</h2>
              <p className="text-sm leading-relaxed text-zinc-400">{s.body}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-zinc-500 mt-10">
          Last updated: April 2026 · Report violations in our{" "}
          <a href={DISCORD_URL} className="text-red-400 hover:text-red-300 underline" target="_blank" rel="noreferrer">
            Discord #report
          </a>{" "}
          channel.
        </p>
      </section>
      <Footer discordUrl={DISCORD_URL} />
    </div>
  );
}
